import { Navigate } from 'react-router'

export default function PackingSlipIndex() {
  return <Navigate to="general" replace />
}
